import { catalog } from "../i18n.js";

/** Why a dictation ended early (dictation.ts, dictationProblemText). */
export const DICTATION = catalog(
  {
    problemDenied: "The microphone is blocked. Allow it in the browser or the phone's settings to dictate.",
    problemNoSpeech: "Nothing was heard. Tap the mic and speak.",
    problemNoMic: "No microphone was found.",
    problemNetwork: "Dictation needs a connection. Try again when you are online.",
    problemLanguage: "This device cannot dictate in that language. Switch the language and try again.",
    problemFailed: "Dictation stopped. Try again.",
  },
  {
    problemDenied: "Mikrofon diblokir. Izinkan di pengaturan browser atau HP untuk mendikte.",
    problemNoSpeech: "Tidak ada suara yang terdengar. Ketuk mikrofon lalu bicara.",
    problemNoMic: "Mikrofon tidak ditemukan.",
    problemNetwork: "Dikte butuh koneksi internet. Coba lagi saat kamu online.",
    problemLanguage: "Perangkat ini tidak bisa mendikte dalam bahasa itu. Ganti bahasanya lalu coba lagi.",
    problemFailed: "Dikte berhenti. Coba lagi.",
  },
);
